// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"project-student-submit_toolbar__2xeiw","cardContainer":"project-student-submit_cardContainer__1MC3b","taskName":"project-student-submit_taskName__3dHm6"};